import React from 'react'
import queryString from 'query-string'
import { Grid, Form, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Title } from '../components'
import {
  loadResults,
  clearResults,
  getResultsCSV,
  getCertificatesZip,
} from '../../common/results/actions'
import { checkFile, clearDownload, checkZipFile, clearZipDownload } from '../../common/downloads/actions'
import { lists } from '../../common/lib/redux-lists'
import {
  TextFilter,
  FromToFilter,
  CompanyFilter,
  LocationFilter,
  BooleanFilter,
  InstructorOnFilter,
  CourseTypeFilter,
  ResultFilter,
} from '../components/filters'

import { ResultsTable } from '../tables'

const { Row, Column } = Grid

const getDriverFromQuery = (props) => {
  const search = queryString.parse(props.location.search)
  return search.driver
}

const willReceiveParams = (oldProps, newProps) => {
  const oldDriverID = getDriverFromQuery(oldProps)
  const newDriverID = getDriverFromQuery(newProps)
  if (oldDriverID !== newDriverID) {
    newProps.list.filters.driver.onChange({ value: newDriverID })
  }
}

class ResultsPage extends React.Component {
  constructor(props) {
    super(props)

    this.getCSV = this.getCSV.bind(this)
    this.checkFile = this.checkFile.bind(this)
    this.checkZipFile = this.checkZipFile.bind(this)
  }
  componentWillMount() {
    const driverID = getDriverFromQuery(this.props)
    if (driverID) this.props.list.$resetFilters()
  }
  componentWillReceiveProps(props) {
    this.willReceiveCsvLocation(this.props, props)
    this.willReceiveZipLocation(this.props, props)
    willReceiveParams(this.props, props)
  }
  componentWillUnmount() {
    const { clearDownload, clearZipDownload, clearResults } = this.props
    clearResults()
    clearDownload()
    clearZipDownload()
    window.clearInterval(this.checkCSVInterval)
    window.clearInterval(this.checkZipInterval)
  }
  getCSV() {
    const { list, getResultsCSV } = this.props
    const query = list.$query()
    getResultsCSV(query)
  }
  getCertificates() {
    const { list, getCertificatesZip } = this.props
    const query = list.$query()
    getCertificatesZip(query)
  }
  willReceiveZipLocation(oldProps, newProps) {
    const oldLocation = oldProps.downloadZipLocation
    const oldPath = oldProps.downloadZipPath
    const newLocation = newProps.downloadZipLocation
    const newPath = newProps.downloadZipPath

    if (oldLocation !== newLocation && newLocation !== '') {
      newProps.checkZipFile(newLocation)
      this.checkZipInterval = window.setInterval(this.checkZipFile, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkZipInterval)
    }
  }
  willReceiveCsvLocation(oldProps, newProps) {
    const oldLocation = oldProps.downloadLocation
    const oldPath = oldProps.downloadPath
    const newLocation = newProps.downloadLocation
    const newPath = newProps.downloadPath

    if (oldLocation !== newLocation && newLocation !== '') {
      newProps.checkFile(newLocation)
      this.checkCSVInterval = window.setInterval(this.checkFile, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkCSVInterval)
    }
  }
  checkFile() {
    const { checkFile, downloadLocation } = this.props
    checkFile(downloadLocation)
  }
  checkZipFile() {
    const { checkZipFile, downloadZipLocation } = this.props
    checkZipFile(downloadZipLocation)
  }
  render() {
    const {
      results,
      meta,
      viewer,
      list,
      waitingForDownload,
      downloadPath,
      clearDownload,
      waitingForZipDownload,
      downloadZipPath,
      clearZipDownload,
    } = this.props

    const driverId = getDriverFromQuery(this.props)
    return (
      <div>
        <Title message="Hodnocení" />
        <aside className="breadcrumbs">
          <span to="/results">Hodnocení</span>
          {['FLEET_MANAGER', 'ADMIN', 'SUPERVISOR'].indexOf(viewer.role) !== -1 &&
            <div className="options">
              {!downloadZipPath && waitingForZipDownload &&
                <button><Icon loading name="spinner" /></button>
              }
              {!downloadZipPath && !waitingForZipDownload &&
                <button type="button" onClick={() => this.getCertificates()}>Hromadný export certifikátů a protokolů</button>
              }
              {downloadZipPath &&
                <a href={downloadZipPath} rel="noopener noreferrer" target="_blank" onClick={clearZipDownload}>
                  <button>Soubor připraven, klikněte pro stažení</button>
                </a>
              }
            </div>
          }
        </aside>
        <main className="content">
          <Form className="filters" size="big">
            <Grid>
              <Row columns={6}>
                {!driverId &&
                <Column>
                  <strong>Jméno řidiče:</strong>
                  <TextFilter {...list.filters['driverNameSearch.likeFold']} />
                </Column>}
                <Column>
                  <strong>Pracovní poměr ukončen:</strong>
                  <BooleanFilter {...list.filters.driverEmploymentFinished} />
                </Column>
                <Column>
                  <strong>Datum:</strong>
                  <FromToFilter fieldFrom={list.filters['testedAt.from']} fieldTo={list.filters['testedAt.to']} />
                </Column>
                {['FLEET_MANAGER', 'ADMIN'].indexOf(viewer.role) !== -1 &&
                  <Column>
                    <strong>Datum zveřejnění:</strong>
                    <FromToFilter
                      fieldFrom={list.filters['closedBySupervisorAt.from']}
                      fieldTo={list.filters['closedBySupervisorAt.to']}
                    />
                  </Column>
                }
                <Column>
                  <strong>Lokace:</strong>
                  <LocationFilter multiple {...list.filters['location.in']} />
                </Column>
                {viewer.role !== 'FLEET_MANAGER' &&
                  <Column>
                    <strong>Dopravce:</strong>
                    <CompanyFilter multiple {...list.filters['company.in']} />
                  </Column>
                }
              </Row>
              {['SUPERVISOR', 'ADMIN'].indexOf(viewer.role) !== -1 &&
                <Row columns={6}>
                  <Column>
                    <strong>Výrok:</strong>
                    <ResultFilter {...list.filters.result} />
                  </Column>
                  <Column>
                    <strong>Uzavřeno instruktorem:</strong>
                    <BooleanFilter {...list.filters.closedByInstructor} options={['Ano', 'Ne']} />
                  </Column>
                  <Column>
                    <strong>Instruktor:</strong>
                    <InstructorOnFilter multiple {...list.filters['testedBy.in']} />
                  </Column>
                  <Column>
                    <strong>Stav uzavření:</strong>
                    <BooleanFilter {...list.filters.closedBySupervisor} options={['Uzavřeno', 'Neuzavřeno']} />
                  </Column>
                  <Column>
                    <strong>Typ akce:</strong>
                    <CourseTypeFilter multiple {...list.filters['courseType.in']} />
                  </Column>
                  <Column>
                    <strong>Blokované:</strong>
                    <BooleanFilter {...list.filters.archived} options={['Ano', 'Ne']} />
                  </Column>
                </Row>
              }
              {['SUPERVISOR', 'PSYCHOLOGIST', 'PC_OPERATOR'].indexOf(viewer.role) === -1 &&
                <Row columns={5}>
                  <Column>
                    <strong>Typ:</strong>
                    <CourseTypeFilter multiple {...list.filters['courseType.in']} />
                  </Column>
                  <Column>
                    <strong>Výrok:</strong>
                    <ResultFilter {...list.filters.result} />
                  </Column>
                </Row>
              }
            </Grid>
          </Form>
          <ResultsTable
            results={results}
            meta={meta}
            list={list}
            role={viewer.role}
            getCSV={['ADMIN','SUPERVISOR'].indexOf(viewer.role) !== -1 && this.getCSV}
            waitingForDownload={waitingForDownload}
            csv={downloadPath}
            clearDownload={clearDownload}
          />
        </main>
      </div>
    )
  }
}

ResultsPage.defaultProps = {
  waitingForDownload: false,
  downloadPath: '',
  downloadLocation: '',
  waitingForZipDownload: false,
  downloadZipPath: '',
  downloadZipLocation: '',
}

ResultsPage.propTypes = {
  results: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  loadResults: React.PropTypes.func.isRequired,
  clearResults: React.PropTypes.func.isRequired,
  list: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  waitingForDownload: React.PropTypes.bool,
  downloadPath: React.PropTypes.string,
  downloadLocation: React.PropTypes.string,
  getResultsCSV: React.PropTypes.func.isRequired,
  getCertificatesZip: React.PropTypes.func.isRequired,
  checkFile: React.PropTypes.func.isRequired,
  clearDownload: React.PropTypes.func.isRequired,
  waitingForZipDownload: React.PropTypes.bool,
  downloadZipPath: React.PropTypes.string,
  downloadZipLocation: React.PropTypes.string,
  checkZipFile: React.PropTypes.func.isRequired,
  clearZipDownload: React.PropTypes.func.isRequired,
}

ResultsPage = lists(ResultsPage, {
  path: 'ResultsPage',
  filters: [
    'driverNameSearch.likeFold',
    'driverBirthdate.from',
    'driverBirthdate.to',
    'driverEmploymentFinished',
    'testedAt.from',
    'testedAt.to',
    'company.in',
    'location.in',
    'instructor.in',
    'closedByInstructor',
    'closedBySupervisor',
    'closedBySupervisorAt.from',
    'closedBySupervisorAt.to',
    'courseType.in',
    'testedBy.in',
    'driver',
    'result',
    'archived',
  ],
  headings: [
    'driverLastNameSort', 'driverFirstNameSort', 'driverBirthdate', 'testedAt', 'closedAt', 'companyNameSort',
    'locationNameSort', 'courseType', 'trafficRulesTestPoints', 'safetyFactor', 'closedBySupervisorAt',
  ],
  debounceTime: 600,
  loadDataAction: props => query => props.loadResults(Object.assign({ platform: 'web' }, query)),
  getInitialState: (props) => {
    const driverID = getDriverFromQuery(props)
    const sort = '-testedAt'
    const query = {
      sort,
      filters: {
          archived: false,
      }
    }
    if (driverID) {
      Object.assign(query, {
        filters: {
          driver: driverID,
        },
      })
    }
    return query
  },
})

export default connect((state) => ({
  results: state.results.all,
  meta: state.results.meta,
  viewer: state.users.viewer,
  waitingForDownload: state.downloads.downloading,
  downloadPath: state.downloads.path,
  downloadLocation: state.downloads.location,
  waitingForZipDownload: state.downloads.zipDownloading,
  downloadZipPath: state.downloads.zipPath,
  downloadZipLocation: state.downloads.zipLocation,
}), {
  loadResults,
  clearResults,
  getResultsCSV,
  checkFile,
  clearDownload,
  getCertificatesZip,
  checkZipFile,
  clearZipDownload,
})(ResultsPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Results.js